// Class Attendance Management
export const classAttendanceStudentInfoApi = 'student-management/student-attendance/student-info'
export const classAttendanceStudentAttendanceInfoApi = 'student-management/student-attendance/student-attendance-info'
export const classAttendanceListApi = 'student-management/student-attendance/list'
export const classAttendanceStoreApi = 'student-management/student-attendance/store'
export const classAttendanceUpdateApi = 'student-management/student-attendance/update'

// Hostel
export const hostelAssignList = 'student-management/hostel/list'
export const hostelAssignAdd = 'student-management/hostel/store'
export const hostelAssignUpdate = 'student-management/hostel/update'
export const studentInfo = 'student-management/hostel/student'

// Parent Training
export const ParentTrainingList = 'student-management/parent-training/list'
export const ParentTrainingAdd = 'student-management/parent-training/store'
export const ParentTrainingUpdate = 'student-management/parent-training/update'

// Student drop release
export const StudentDropReleaseList = 'student-management/drop-release/list'
export const StudentDropReleaseListAll = 'student-management/drop-release/index'
export const StudentDropReleasenAdd = 'student-management/drop-release/store'
export const StudentDropReleasenUpdate = 'student-management/drop-release/update'

// student-therapy-management
export const studentTherapyListApi = 'student-management/student-therapy-management/list'
export const studentTherapyAddApi = 'student-management/student-therapy-management/store'
export const studentTherapyUpdateApi = 'student-management/student-therapy-management/update'
export const studentInfoApi = 'student-management/student-therapy-management/student'
export const getTherapyByOfficeApi = 'student-management/student-therapy-management/therapy-center-by-office'
export const LibraryBookDistributionStudentListApi = 'institute-management/library-book-distribution/studentlist'

// student Profile
export const studentProfileList = 'student-management/student-profile/list'
export const studentProfileListApi = 'student-management/student-profile/studentlist'
export const studentProfileDetailsApi = 'student-management/student-profile/details'

// class promotion
export const classPromotionList = 'student-management/class-promotion/list'
export const promoteClassUpdateApi = 'student-management/class-promotion/promote-class'
export const studentClassHistoryApi = 'student-management/class-promotion/class-history'

// individual-education-plan
export const curricularListApi = 'student-management/individual-education-plan/curriculum'
export const planStoreApi = 'student-management/individual-education-plan/store'
export const planUpdateApi = 'student-management/individual-education-plan/update'
export const planListApi = 'student-management/individual-education-plan/index'

// individual  assessment
export const studentAssessmentList = 'student-management/individual-assessment/list'
export const studentAssessmentDetailsApi = 'student-management/individual-assessment/detail'
export const getStudentCurricularApi = 'student-management/individual-assessment/student-curricular'
export const studentAssessmentStoreApi = 'student-management/individual-assessment/store'
export const studentAssessmentReportApi = 'student-management/individual-assessment/report'
